/* Vienetta Hesaba Özel Sepet (24.09.2026)
 *
 * Sepetin tek doğru kaynağı backend veritabanıdır (hesap e-postasına bağlı). Tarayıcıdaki Shopify sepeti
 * yalnız bu kaydın kopyasıdır; tarayıcıda sepet saklanmaz, birleştirilmez. Hesap hangi cihazda açılırsa
 * açılsın aynı sepet gelir; temsilci aynı tarayıcıda farklı müşteri hesaplarına girse de sepetler karışmaz.
 *
 * - Sayfa açılışı: backend sepeti çekilir, Shopify sepeti ondan farklıysa temizlenip backend'dekiyle
 *   yeniden kurulur (eklenemeyen/arşivli kalem atlanır, gerçekte oluşan sepet backend'e yazılır).
 * - Değişim: /cart/add|change|update|clear sonrası Shopify sepeti backend'e yazılır. İlk eşitleme
 *   bitmeden yazılmaz (tarayıcıda önceki hesaptan kalan sepet yeni hesaba geçmesin).
 * - Backend'e ulaşılamazsa ve tarayıcıdaki sepet başka hesaba aitse sepet temizlenir.
 * - Çıkış: /account/logout linkine basınca Shopify sepeti temizlenir.
 *
 * Tarayıcıda yalnız "bu Shopify sepeti hangi hesabın kopyası" bilgisi (e-posta) tutulur, sepet verisi tutulmaz.
 * Kimlik: window.customerData.email (yalnız giriş yapmış müşteride). Misafirde çalışmaz.
 * Marka backend'de brand='vienetta' -> KZK sepetiyle çakışmaz.
 */
(function () {
  'use strict';

  var API = window.KZK_API_BASE || 'https://senko.toserof.com';
  var CART_URL = API + '/api/vienetta-cart';
  var SAHIP_KEY = 'vie_cart_owner';
  var _applying = false;
  var _pushTimer = null;
  var _syncing = false;
  var _hazir = false;
  var _yenileniyor = false;
  var _hazirCoz;
  var _hazirSoz = new Promise(function (coz) { _hazirCoz = coz; });

  function email() { return String((window.customerData && window.customerData.email) || '').trim().toLowerCase(); }
  function loggedIn() { return !!email(); }

  function sahip() { try { return localStorage.getItem(SAHIP_KEY) || ''; } catch (e) { return ''; } }
  function sahipYaz(v) { try { if (v) localStorage.setItem(SAHIP_KEY, v); else localStorage.removeItem(SAHIP_KEY); } catch (e) {} }

  function getShopifyCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function itemsKey(items) {
    return (items || []).map(function (i) { return (i.id != null ? i.id : i.variant_id) + ':' + i.quantity; }).sort().join('|');
  }
  function mapItems(items) {
    return (items || []).map(function (i) {
      var o = { id: (i.id != null ? i.id : i.variant_id), quantity: i.quantity };
      if (i.properties && Object.keys(i.properties).length) o.properties = i.properties;
      return o;
    });
  }

  function saveToBackend(items) {
    return fetch(CART_URL, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email(), items: mapItems(items) })
    });
  }

  /* Shopify sepetini backend'e yaz (debounced). İlk eşitleme bitmeden ve sepet başka hesaba aitken yazmaz. */
  function pushToBackend() {
    if (_applying || !_hazir || !loggedIn()) return;
    if (_pushTimer) clearTimeout(_pushTimer);
    _pushTimer = setTimeout(function () {
      _pushTimer = null;
      if (_applying || !_hazir || !loggedIn() || sahip() !== email()) return;
      getShopifyCart().then(function (cart) { return saveToBackend(cart.items); }).catch(function () {});
    }, 700);
  }

  /* Shopify tek istekte bir kalem bile eklenemezse (arşivlenmiş/satıştan kalkmış ürün) HİÇBİRİNİ eklemez.
   * Bu yüzden önce toplu, olmazsa 10'luk gruplar, grup da olmazsa tek tek eklenir; eklenemeyen kalem atlanır. */
  function addJs(list) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: list })
    }).then(function (r) { return r.ok; }, function () { return false; });
  }
  function addSequential(list, i) {
    if (i >= list.length) return Promise.resolve();
    return addJs([list[i]]).then(function () { return addSequential(list, i + 1); });
  }
  function addInChunks(list, size, i) {
    if (i >= list.length) return Promise.resolve();
    var chunk = list.slice(i, i + size);
    return addJs(chunk)
      .then(function (ok) { return ok ? null : addSequential(chunk, 0); })
      .then(function () { return addInChunks(list, size, i + size); });
  }
  function addResilient(items) {
    var list = mapItems(items);
    return addJs(list).then(function (ok) { return ok ? null : addInChunks(list, 10, 0); });
  }

  function temizle() {
    return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
  }

  /* Backend sepetini Shopify'a uygula (temizle + dayanıklı ekle) */
  function applyToShopify(items) {
    _applying = true;
    return temizle()
      .then(function () { return items && items.length ? addResilient(items) : null; })
      .then(function () { try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {} })
      .catch(function () {})
      .finally(function () { _applying = false; });
  }

  /* Sayfa açılışı: backend sepeti tek doğru kaynak; Shopify sepeti ona eşitlenir. */
  function syncFromBackend() {
    if (_syncing || !loggedIn()) return;
    _syncing = true;
    var hesap = email();
    Promise.all([
      fetch(CART_URL + '?email=' + encodeURIComponent(hesap)).then(function (r) { return r.ok ? r.json() : null; }, function () { return null; }),
      getShopifyCart()
    ]).then(function (res) {
      var backend = res[0], shopify = res[1];

      if (!backend || !backend.ok) {
        if (sahip() && sahip() !== hesap && shopify.items && shopify.items.length) {
          _applying = true;
          return temizle().then(function () {
            sahipYaz('');
            try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
          }).finally(function () { _applying = false; });
        }
        return;
      }

      var hedef = mapItems(backend.items);
      var hedefKey = itemsKey(hedef);
      if (hedefKey === itemsKey(shopify.items)) { sahipYaz(hesap); _hazir = true; return; }

      return applyToShopify(hedef).then(function () {
        return getShopifyCart();
      }).then(function (after) {
        sahipYaz(hesap);
        _hazir = true;
        var afterKey = itemsKey(after.items);
        var yaz = afterKey !== hedefKey ? saveToBackend(after.items) : Promise.resolve();
        return yaz.then(function () {
          if (afterKey !== itemsKey(shopify.items)) { _yenileniyor = true; window.location.reload(); }
        });
      });
    }).catch(function () {}).finally(function () {
      _syncing = false;
      if (!_yenileniyor) _hazirCoz();
    });
  }

  window.VieCartSync = {
    hazir: _hazirSoz,
    kaydet: function () {
      if (!_hazir || !loggedIn() || sahip() !== email()) return Promise.resolve(false);
      return getShopifyCart()
        .then(function (cart) { return saveToBackend(cart.items); })
        .then(function (r) { return !!(r && r.ok); }, function () { return false; });
    }
  };

  /* --- Cart yazma isteklerini yakala (fetch interception) --- */
  var _origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var isWrite = /\/cart\/(add|change|update|clear)(\.js)?(\?|$|#)/.test(url);
    var p = _origFetch.apply(this, arguments);
    if (isWrite && !_applying) {
      p.then(function (res) { if (res && res.ok) pushToBackend(); }).catch(function () {});
    }
    return p;
  };

  /* --- Çıkış: /account/logout linkine basınca Shopify sepetini temizle --- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/account/logout"]');
    if (!a) return;
    sahipYaz('');
    try {
      if (navigator.sendBeacon) navigator.sendBeacon('/cart/clear.js');
      else fetch('/cart/clear.js', { method: 'POST', keepalive: true });
    } catch (err) {}
  }, true);

  /* Boot: girişliyse hemen eşitle */
  if (loggedIn()) syncFromBackend();
  else _hazirCoz();
})();
